const createHeading = (selectedRows: any[], singular: string, plural: string) => `${selectedRows.length} selected ${selectedRows.length === 1 ? singular : plural}`;

export default createHeading;
